import { motion } from 'framer-motion';

export const CTA = () => {
  const scrollToRoulette = () => {
    const el = document.getElementById('roulette');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-24 relative overflow-hidden bg-charcoal-900 border-t border-gray-800">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold-900/20 via-charcoal-900 to-charcoal-950" />
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-gold-900/10 to-transparent" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto bg-charcoal-800/80 backdrop-blur border border-gold-500/20 p-12 md:p-16 rounded-3xl shadow-2xl"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            The Wheel Is <span className="text-gold-500">Waiting</span>
          </h2>
          <p className="text-gray-400 text-lg md:text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
            Experience a beautifully designed interactive Roulette demo. Spin. Feel the thrill. Play the game — with virtual chips only.
          </p>
          
          <button
            onClick={scrollToRoulette}
            className="px-10 py-5 bg-gold-600 hover:bg-gold-500 text-white rounded-full font-bold text-lg transition-all shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_30px_rgba(212,175,55,0.5)] transform hover:-translate-y-1 inline-flex items-center gap-3"
          >
            TRY DEMO
          </button>
          
          <div className="mt-8 text-xs text-gray-500 font-medium tracking-widest uppercase">
            18+ | PLAY RESPONSIBLY | DEMO EXPERIENCE
          </div>
        </motion.div>
      </div>
    </section>
  );
};
